import React, { Component } from "react";
import Proptypes from "prop-types";

export default class ViewGcpDnsProviderConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { currentDnsProviderConfig } = this.props;
        return (
            <React.Fragment>
                <tr><td><h4>Name</h4></td><td>{currentDnsProviderConfig.config_name || "-"}</td></tr>
                <tr><td><h4>Project</h4></td><td>{currentDnsProviderConfig.gcp_project}</td></tr>
                <tr><td><h4>Credentials</h4></td><td>{currentDnsProviderConfig.gcp_credentials}</td></tr>
            </React.Fragment>
        );
    }
}

ViewGcpDnsProviderConfig.propTypes = {
    currentDnsProviderConfig: Proptypes.object.isRequired,
};
